import { gql, useQuery } from '@apollo/client';
import * as React from 'react';

import { MembershipCtaCard } from '@/components/MembershipCtaCard';
import { useMemberManagement } from '@/hooks/useMemberManagement';

import { MembershipSupportingContent_CurrentUser } from './graphql-types/MembershipSupportingContent_CurrentUser';

import { tokenStorage } from '../../modules/accounts/tokenStorage';

const CURRENT_USER = gql`
  query MembershipSupportingContent_CurrentUser {
    currentUser {
      _id
      firstName
      membershipData {
        ...MembershipCtaCard_MembershipDataFragment
      }
      rosterOrganization {
        _id
        displayName
        membershipData {
          ...MembershipCtaCard_MembershipDataFragment
        }
      }
    }
  }
  ${MembershipCtaCard.membershipDataFragment}
`;

export const MembershipSupportingContent: React.FC = () => {
  const memberManagement = useMemberManagement();

  const query = useQuery<MembershipSupportingContent_CurrentUser>(
    CURRENT_USER,
    {
      skip: !memberManagement.isActive,
    }
  );

  if (!memberManagement.isActive) {
    return null;
  }

  if (!tokenStorage.getItem('isMobile')) {
    if (query.data?.currentUser?.membershipData) {
      return (
        <MembershipCtaCard
          membershipData={query.data.currentUser.membershipData}
          userFirstName={query.data.currentUser.firstName}
          shouldBeMemberView
        />
      );
    }

    if (query.data?.currentUser?.rosterOrganization?.membershipData) {
      return (
        <MembershipCtaCard
          membershipData={
            query.data.currentUser.rosterOrganization.membershipData
          }
          organizationName={
            query.data.currentUser.rosterOrganization.displayName
          }
          shouldBeMemberView
        />
      );
    }
  }

  return null;
};
